//
// Reel manager class
//
// Used to create and manage reels

reelManager = {};
reelManager.reels = [];
reelManager.symbolWidth = 0;
reelManager.symbolHeight = 0;

reelManager.createReel = function (json) {
  var reel = reelTemplate.createReel(reelManager.reels.length, json);
  reelManager.reels.push(reel);
  return reel;
};
reelManager.createInfiniReel = function (json) {
  var reel = infiniReelTemplate.createReel(-1, json);
  reelManager.reels.push(reel);
  return reel;
};

reelManager.destroyReel = function (reel) {
  var index = reelManager.reels.indexOf(reel);
  if (index === -1) {
    console.log("Could not destroy reel as it could not be found");
    return;
  }

  reelManager.reels.splice(index, 1);
};

reelManager.initialiseReel = function (json) {
  resourceManager.get(json.FQN).initialise(json);
};

reelManager.update = function (delta) {
  for (var i = 0; i < reelManager.reels.length; i++) {
    reelManager.reels[i].update(delta);
  }
};

reelManager.getReelFiles = function (json) {
  var reelFilesList = [];
  var symbolTemplate = resourceManager.getConfiguration().symbols;
  var keys = Object.keys(symbolTemplate);
  for (var i = 0; i < keys.length; i++) {
    // Add files needed for this symbol
    var symbolFiles = textureParser.getFilesRequired(
      symbolTemplate[keys[i]].texture
    );
    reelFilesList = reelFilesList.concat(
      textureParser.getFilesRequired(symbolTemplate[keys[i]].texture)
    );
  }
  return reelFilesList;
};

reelManager.onResize = function () {
  for (var i = 0; i < reelManager.reels.length; ++i) {
    reelManager.reels[i].updateSymbols();
  }
};

Reflex.addToUpdate(reelManager.update);
Reflex.registerEventHandler("resize", reelManager.onResize);
resourceManager.registerObjectType(
  "reel",
  reelManager.createReel,
  reelManager.initialiseReel,
  reelManager.getReelFiles,
  reelManager.destroyReel
);
resourceManager.registerObjectType(
  "infiniReel",
  reelManager.createInfiniReel,
  reelManager.initialiseReel,
  reelManager.getReelFiles,
  reelManager.destroyReel
);
